class FullWidthMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  handleTrigger () {
    this.setAttribute('data-modal-open', 'true')
    document.body.classList.toggle('util-SiteOverflowed', true)
    this.els.modal.element.setAttribute('aria-hidden', 'false')

    for (const source in this.els.video.element.children) {
      const videoSource = this.els.video.element.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.els.video.element.load()
    this.els.video.element.play()
  }

  handleClose () {
    this.els.modal.element.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)

    this.els.video.element.pause()
  }
}

if (!customElements.get('full-width-media')) {
  customElements.define('full-width-media', FullWidthMedia)
}
